import { render, staticRenderFns } from "./Iugu.vue?vue&type=template&id=700ea17c&"
import script from "./Iugu.vue?vue&type=script&lang=ts&"
export * from "./Iugu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports